import { useState } from 'react';
import type { Invoice } from '../../types';
import AdminDrawer from '../AdminDrawer';

const invoices: Invoice[] = [
  { id: 'i1',  number: 'BOO-2025-012', client: 'Bratislava Pet Shop',  clientInitials: 'BS', clientColor: 'bg-emerald-600', amount: 1200, status: 'paid',    issued: '1.3.2025',  due: '15.3.2025', service: 'Growth balíček – mar'   },
  { id: 'i2',  number: 'BOO-2025-013', client: 'TechFlow s.r.o.',      clientInitials: 'TF', clientColor: 'bg-sky-600',     amount: 2400, status: 'paid',    issued: '1.3.2025',  due: '15.3.2025', service: 'Scale balíček – mar'     },
  { id: 'i3',  number: 'BOO-2025-014', client: 'VitaBenefit s.r.o.',   clientInitials: 'VB', clientColor: 'bg-violet-600',  amount: 980,  status: 'paid',    issued: '1.3.2025',  due: '15.3.2025', service: 'Starter balíček – mar'   },
  { id: 'i4',  number: 'BOO-2025-015', client: 'Petra K. – Kozmetika', clientInitials: 'PK', clientColor: 'bg-pink-600',    amount: 650,  status: 'paid',    issued: '5.3.2025',  due: '19.3.2025', service: 'Starter balíček – mar'   },
  { id: 'i5',  number: 'BOO-2025-016', client: 'MotoLux SK',           clientInitials: 'ML', clientColor: 'bg-orange-600',  amount: 1600, status: 'paid',    issued: '8.3.2025',  due: '22.3.2025', service: 'Growth balíček – mar'    },
  { id: 'i6',  number: 'BOO-2025-017', client: 'JH Legal s.r.o.',      clientInitials: 'JH', clientColor: 'bg-indigo-600',  amount: 2200, status: 'pending', issued: '1.4.2025',  due: '15.4.2025', service: 'Scale balíček – apr'     },
  { id: 'i7',  number: 'BOO-2025-018', client: 'AutoMech Prešov',      clientInitials: 'MR', clientColor: 'bg-zinc-600',    amount: 750,  status: 'overdue', issued: '1.2.2025',  due: '15.2.2025', service: 'Growth balíček – feb'    },
  { id: 'i8',  number: 'BOO-2025-019', client: 'FreshAir s.r.o.',      clientInitials: 'FA', clientColor: 'bg-teal-600',    amount: 200,  status: 'paid',    issued: '10.3.2025', due: '24.3.2025', service: 'Jednorazový web audit'   },
  { id: 'i9',  number: 'BOO-2025-020', client: 'Bratislava Pet Shop',  clientInitials: 'BS', clientColor: 'bg-emerald-600', amount: 1200, status: 'pending', issued: '1.4.2025',  due: '15.4.2025', service: 'Growth balíček – apr'    },
  { id: 'i10', number: 'BOO-2025-021', client: 'TechFlow s.r.o.',      clientInitials: 'TF', clientColor: 'bg-sky-600',     amount: 2400, status: 'pending', issued: '1.4.2025',  due: '15.4.2025', service: 'Scale balíček – apr'     },
];

const invoiceDetails: Record<string, { items: { desc: string; qty: number; unit: number }[]; note: string; paymentRef?: string }> = {
  i1:  { items: [{ desc: 'Growth marketing balíček – Marec 2025', qty: 1, unit: 1200 }], note: 'Ďakujeme za včasnú platbu!', paymentRef: 'REF-2025-0312-BS' },
  i2:  { items: [{ desc: 'Scale marketing balíček – Marec 2025', qty: 1, unit: 2400 }], note: 'Platba prijatá 14.3.2025.', paymentRef: 'REF-2025-0314-TF' },
  i3:  { items: [{ desc: 'Starter marketing balíček – Marec 2025', qty: 1, unit: 980 }], note: '', paymentRef: 'REF-2025-0313-VB' },
  i4:  { items: [{ desc: 'Starter marketing balíček – Marec 2025', qty: 1, unit: 650 }], note: '', paymentRef: 'REF-2025-0319-PK' },
  i5:  { items: [{ desc: 'Growth marketing balíček – Marec 2025', qty: 1, unit: 1600 }], note: '', paymentRef: 'REF-2025-0322-ML' },
  i6:  { items: [{ desc: 'Scale marketing balíček – Apríl 2025', qty: 1, unit: 2200 }], note: 'Prosím uhradiť do splatnosti.', },
  i7:  { items: [{ desc: 'Growth marketing balíček – Február 2025', qty: 1, unit: 750 }], note: 'Faktúra po splatnosti – kontaktujte klienta!', },
  i8:  { items: [{ desc: 'Web audit – jednorazový', qty: 1, unit: 200 }], note: 'Jednorazová platba za audit.', paymentRef: 'REF-2025-0324-FA' },
  i9:  { items: [{ desc: 'Growth marketing balíček – Apríl 2025', qty: 1, unit: 1200 }], note: '', },
  i10: { items: [{ desc: 'Scale marketing balíček – Apríl 2025', qty: 1, unit: 2400 }], note: '', },
};

const statusStyle: Record<Invoice['status'], string> = {
  paid:    'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  pending: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  overdue: 'bg-red-500/10 text-red-400 border-red-500/20',
};
const statusLabel: Record<Invoice['status'], string> = { paid: 'Uhradená', pending: 'Čakajúca', overdue: 'Po splatnosti' };
const statusIcon: Record<Invoice['status'], string> = { paid: 'ri-checkbox-circle-line', pending: 'ri-time-line', overdue: 'ri-alarm-warning-line' };

export default function AdminFaktury() {
  const [filter, setFilter] = useState<'all' | Invoice['status']>('all');
  const [selected, setSelected] = useState<Invoice | null>(null);
  const [invStatuses, setInvStatuses] = useState<Record<string, Invoice['status']>>({});

  const getStatus = (inv: Invoice): Invoice['status'] => invStatuses[inv.id] ?? inv.status;

  const filtered = filter === 'all' ? invoices : invoices.filter((i) => getStatus(i) === filter);

  const totalPaid    = invoices.filter((i) => getStatus(i) === 'paid').reduce((s, i) => s + i.amount, 0);
  const totalPending = invoices.filter((i) => getStatus(i) === 'pending').reduce((s, i) => s + i.amount, 0);
  const totalOverdue = invoices.filter((i) => getStatus(i) === 'overdue').reduce((s, i) => s + i.amount, 0);

  const markAs = (id: string, s: Invoice['status']) => setInvStatuses((prev) => ({ ...prev, [id]: s }));

  return (
    <div className="h-full overflow-y-auto p-6 space-y-5">
      {/* Summary */}
      <div className="grid grid-cols-3 gap-4">
        {[
          { label: 'Uhradené (tento mesiac)', amount: totalPaid,    icon: 'ri-checkbox-circle-line', color: 'text-emerald-400', bg: 'bg-emerald-500/10' },
          { label: 'Čakajúce platby',         amount: totalPending, icon: 'ri-time-line',             color: 'text-amber-400',   bg: 'bg-amber-500/10'   },
          { label: 'Po splatnosti',            amount: totalOverdue, icon: 'ri-alarm-warning-line',    color: 'text-red-400',     bg: 'bg-red-500/10'     },
        ].map((s) => (
          <div key={s.label} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4 flex items-center gap-4">
            <div className={`w-11 h-11 rounded-xl ${s.bg} flex items-center justify-center flex-shrink-0`}>
              <i className={`${s.icon} ${s.color} text-xl`} />
            </div>
            <div>
              <p className="text-zinc-500 text-xs">{s.label}</p>
              <p className="text-white text-xl font-black mt-0.5">{s.amount.toLocaleString()} €</p>
            </div>
          </div>
        ))}
      </div>

      {/* Filter + actions */}
      <div className="flex items-center gap-3">
        {(['all', 'paid', 'pending', 'overdue'] as const).map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-3.5 py-2 rounded-xl text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${filter === s ? 'bg-orange-500/10 border border-orange-500/20 text-orange-400' : 'bg-zinc-900 border border-zinc-800 text-zinc-500 hover:text-zinc-300'}`}>
            {s === 'all' ? 'Všetky' : statusLabel[s]}
          </button>
        ))}
        <div className="flex-1" />
        <button className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-all cursor-pointer whitespace-nowrap">
          <i className="ri-file-add-line text-sm" /> Vystaviť faktúru
        </button>
      </div>

      {/* Table */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              {['Číslo', 'Klient', 'Služba', 'Suma', 'Vystavená', 'Splatnosť', 'Stav', ''].map((h) => (
                <th key={h} className="text-left px-4 py-3 text-zinc-600 text-[11px] font-semibold uppercase tracking-wider first:pl-5">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {filtered.map((inv) => {
              const curStatus = getStatus(inv);
              return (
                <tr key={inv.id} onClick={() => setSelected(inv)} className="hover:bg-zinc-800/40 cursor-pointer transition-all group">
                  <td className="px-4 pl-5 py-3"><span className="text-zinc-300 text-xs font-mono group-hover:text-orange-400 transition-colors">{inv.number}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className={`w-7 h-7 rounded-lg ${inv.clientColor} flex items-center justify-center flex-shrink-0`}>
                        <span className="text-white text-[10px] font-bold">{inv.clientInitials}</span>
                      </div>
                      <span className="text-zinc-300 text-xs font-medium">{inv.client}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3"><span className="text-zinc-500 text-xs">{inv.service}</span></td>
                  <td className="px-4 py-3"><span className="text-white text-sm font-bold">{inv.amount.toLocaleString()} €</span></td>
                  <td className="px-4 py-3"><span className="text-zinc-500 text-xs">{inv.issued}</span></td>
                  <td className="px-4 py-3"><span className={`text-xs ${curStatus === 'overdue' ? 'text-red-400 font-semibold' : 'text-zinc-500'}`}>{inv.due}</span></td>
                  <td className="px-4 py-3">
                    <span className={`text-[10px] font-semibold px-2.5 py-1 rounded-full border ${statusStyle[curStatus]}`}>{statusLabel[curStatus]}</span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-zinc-700 transition-all cursor-pointer" onClick={(e) => e.stopPropagation()}>
                        <i className="ri-download-line text-zinc-500 text-sm" />
                      </button>
                      <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-zinc-800">
                        <i className="ri-arrow-right-line text-zinc-400 text-sm" />
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Invoice detail drawer */}
      {selected && (() => {
        const curStatus = getStatus(selected);
        const detail = invoiceDetails[selected.id];
        const subtotal = detail?.items.reduce((s, i) => s + i.qty * i.unit, 0) ?? selected.amount;
        const vat = Math.round(subtotal * 0.20);
        return (
          <AdminDrawer
            open={!!selected}
            onClose={() => setSelected(null)}
            title={selected.number}
            subtitle={selected.client}
            icon={statusIcon[curStatus]}
            iconBg={curStatus === 'paid' ? 'bg-emerald-600' : curStatus === 'overdue' ? 'bg-red-700' : 'bg-amber-600'}
          >
            <div className="p-5 space-y-5">
              {/* Status banner */}
              <div className={`flex items-center gap-3 p-3.5 rounded-2xl border ${statusStyle[curStatus]}`}>
                <i className={`${statusIcon[curStatus]} text-lg`} />
                <div>
                  <p className="font-semibold text-sm">{statusLabel[curStatus]}</p>
                  <p className="text-[11px] opacity-70 mt-0.5">
                    {curStatus === 'paid' ? `Uhradená dňa ${selected.due}` : curStatus === 'overdue' ? `Splatná bola ${selected.due} – kontaktujte klienta!` : `Splatnosť: ${selected.due}`}
                  </p>
                </div>
              </div>

              {/* Client + dates */}
              <div className="grid grid-cols-2 gap-2">
                {[
                  { label: 'Klient',     value: selected.client,  icon: 'ri-user-3-line'     },
                  { label: 'Služba',     value: selected.service, icon: 'ri-service-line'    },
                  { label: 'Vystavená',  value: selected.issued,  icon: 'ri-calendar-line'   },
                  { label: 'Splatnosť',  value: selected.due,     icon: 'ri-calendar-check-line' },
                ].map((d) => (
                  <div key={d.label} className="bg-zinc-800/50 rounded-xl p-3">
                    <div className="flex items-center gap-1.5 mb-1">
                      <i className={`${d.icon} text-zinc-600 text-xs`} />
                      <p className="text-zinc-600 text-[10px] uppercase tracking-wider font-semibold">{d.label}</p>
                    </div>
                    <p className="text-zinc-200 text-xs font-medium truncate">{d.value}</p>
                  </div>
                ))}
              </div>

              {/* Line items */}
              <div>
                <p className="text-zinc-600 text-[10px] font-bold uppercase tracking-widest mb-2">Položky faktúry</p>
                <div className="bg-zinc-800/40 rounded-xl overflow-hidden">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-zinc-700/50">
                        <th className="text-left px-3 py-2 text-zinc-600 text-[10px] font-semibold uppercase">Popis</th>
                        <th className="text-right px-3 py-2 text-zinc-600 text-[10px] font-semibold uppercase">Ks</th>
                        <th className="text-right px-3 py-2 text-zinc-600 text-[10px] font-semibold uppercase">Cena</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(detail?.items ?? [{ desc: selected.service, qty: 1, unit: selected.amount }]).map((item, i) => (
                        <tr key={i} className="border-b border-zinc-700/30 last:border-0">
                          <td className="px-3 py-2.5 text-zinc-300 text-xs">{item.desc}</td>
                          <td className="px-3 py-2.5 text-zinc-500 text-xs text-right">{item.qty}</td>
                          <td className="px-3 py-2.5 text-zinc-200 text-xs font-semibold text-right">{(item.qty * item.unit).toLocaleString()} €</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="px-3 py-2 border-t border-zinc-700/50 space-y-1">
                    <div className="flex justify-between text-zinc-600 text-xs">
                      <span>Základ dane</span><span>{subtotal.toLocaleString()} €</span>
                    </div>
                    <div className="flex justify-between text-zinc-600 text-xs">
                      <span>DPH 20 %</span><span>{vat.toLocaleString()} €</span>
                    </div>
                    <div className="flex justify-between text-white text-sm font-bold pt-1 border-t border-zinc-700/50 mt-1">
                      <span>Spolu</span><span>{(subtotal + vat).toLocaleString()} €</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Note */}
              {detail?.note && (
                <div className="bg-zinc-800/40 rounded-xl p-3">
                  <p className="text-zinc-600 text-[10px] uppercase tracking-wider font-semibold mb-1">Poznámka</p>
                  <p className="text-zinc-400 text-xs">{detail.note}</p>
                </div>
              )}

              {/* Ref */}
              {detail?.paymentRef && (
                <div className="flex items-center gap-2 bg-emerald-500/5 border border-emerald-500/20 rounded-xl p-3">
                  <i className="ri-secure-payment-line text-emerald-400 text-sm" />
                  <div>
                    <p className="text-zinc-600 text-[10px] uppercase tracking-wider font-semibold">Referencia platby</p>
                    <p className="text-emerald-400 text-xs font-mono mt-0.5">{detail.paymentRef}</p>
                  </div>
                </div>
              )}

              {/* Actions */}
              <div className="flex flex-col gap-2 pt-1">
                {curStatus !== 'paid' && (
                  <button onClick={() => markAs(selected.id, 'paid')} className="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                    <i className="ri-checkbox-circle-line" /> Označiť ako uhradenú
                  </button>
                )}
                <div className="grid grid-cols-2 gap-2">
                  <button className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-xs font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                    <i className="ri-download-line" /> Stiahnuť PDF
                  </button>
                  {curStatus !== 'paid' && (
                    <button className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-xs font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                      <i className="ri-mail-send-line" /> Poslať upomienku
                    </button>
                  )}
                  {curStatus === 'paid' && (
                    <button className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 text-xs font-semibold py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap">
                      <i className="ri-send-plane-line" /> Preposlať klientovi
                    </button>
                  )}
                </div>
              </div>
            </div>
          </AdminDrawer>
        );
      })()}
    </div>
  );
}
